import React from "react";

import type { FilterModalProps } from "./FilterModalProps";
import SaveFilter from "./SaveFilter";
import ViewFilters from "./ViewFilters";
import Modal from "../../Modal/Modal";

const SaveFilterModal = (props: FilterModalProps) => {
  const { isOpened, close } = props;

  let ModalBody = ViewFilters;

  if (isOpened === "newFilter") {
    ModalBody = SaveFilter;
  }

  return (
    <Modal
      isOpened={!!isOpened}
      title={isOpened === "newFilter" ? "Save as View" : "Saved Views"}
      toggle={close}
      focusTrap={false}
    >
      <ModalBody {...props} />
    </Modal>
  );
};

export default SaveFilterModal;
